import { Stack, Typography } from '@mui/material';
import { Popup } from '@vis.gl/react-maplibre';

import PurIcon from '@/assets/icons/map/map-markers/parkride.svg?react';
import CarIcon from '@/assets/icons/park-and-ride/car.svg?react';
import { PopupContent } from '@/components/PopupContent';
import { ForecastBars } from '@/components/map/ForecastBars';
import { StatNumber } from '@/components/map/StatNumber';
import { PopupTitle } from '@/components/popup/PopupTitle';
import { useForecast } from '@/hooks/useForecast';
import type { ParkAndRideFeature } from '@/types/ParkAndRideFeature';

interface ParkAndRidePopupProps {
  feature?: ParkAndRideFeature;
  onClose: () => void;
}

export function ParkAndRidePopup({ feature, onClose }: ParkAndRidePopupProps) {
  const { horizonItems: forecastItems } = useForecast();
  if (!feature) return null;

  const [longitude, latitude] = feature.geometry.coordinates;
  const { name, type, spaces } = feature.properties ?? {};

  return (
    <Popup
      key={name}
      closeButton={false}
      latitude={latitude}
      longitude={longitude}
      maxWidth="min(480px, 75vw)"
      offset={18}
      onClose={onClose}
    >
      <PopupContent onClose={onClose}>
        <Stack
          sx={{
            p: 1,
          }}
        >
          <Stack
            direction="row"
            sx={{
              gap: 1,
            }}
          >
            <PurIcon />
            <Stack direction="column">
              <PopupTitle>{name}</PopupTitle>
              <Typography>{type}</Typography>
            </Stack>
          </Stack>

          <Stack
            direction="row"
            sx={{
              pl: 1.5,
              alignItems: 'flex-end',
              justifyContent: 'space-between',
            }}
          >
            <Stack
              direction="column"
              sx={{
                justifyContent: 'center',
                gap: 0.5,
                height: '100%',
              }}
            >
              <Stack
                direction="row"
                spacing={1}
                sx={{
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <CarIcon />
                <StatNumber>{spaces}</StatNumber>
              </Stack>
              <Stack
                direction="row"
                spacing={0.5}
                sx={{
                  alignItems: 'center',
                }}
              >
                <Typography
                  title="Auto Stellplätze"
                  sx={{
                    display: 'inline',
                    maxWidth: { xs: '100px', sm: '150px' },
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Auto Stellplätze
                </Typography>
              </Stack>
            </Stack>
            <Stack>{forecastItems.length > 0 && <ForecastBars items={forecastItems} />}</Stack>
          </Stack>
        </Stack>
      </PopupContent>
    </Popup>
  );
}
